import { useEffect, useRef, useState } from "react";
import axios from "axios";
import { DEFAULT_SETTINGS, layoutError, settingValues, settingsError } from "./settings";

const URL = `${process.env.REACT_APP_BACKEND_URL}/api/etiketten/instellingen`;
export const useEtiketSettings = (open, firmaId) => {
  const [form, setForm] = useState(DEFAULT_SETTINGS), [saved, setSaved] = useState(null);
  const [loading, setLoading] = useState(false), [saving, setSaving] = useState(false);
  const [error, setError] = useState(""), [reload, setReload] = useState(0);
  const [loadedFirma, setLoadedFirma] = useState(null);
  const generation = useRef(0);
  useEffect(() => {
    const current = ++generation.current, controller = new AbortController();
    if (!open) return () => { generation.current++; };
    setLoading(true); setError(""); setLoadedFirma(null); setSaved(null); setForm(DEFAULT_SETTINGS);
    axios.get(URL, { signal: controller.signal, timeout: 20000, headers: { "X-Firma-Id": firmaId } }).then(({ data }) => {
      if (current !== generation.current) return;
      setForm(settingValues(data)); setSaved(data); setLoadedFirma(firmaId);
    }).catch((e) => {
      if (current === generation.current && !axios.isCancel(e)) setError(settingsError(e));
    }).finally(() => { if (current === generation.current) setLoading(false); });
    return () => { generation.current++; controller.abort(); };
  }, [open, firmaId, reload]);
  const invalid = layoutError(form);
  const ready = Boolean(saved && loadedFirma === firmaId && !loading);
  const dirty = ready && JSON.stringify(settingValues(form)) !== JSON.stringify(settingValues(saved));
  const save = async () => {
    if (!ready || saving || invalid || !saved.mag_opslaan || loadedFirma !== localStorage.getItem("hr_firma")) return false;
    const current = generation.current;
    setSaving(true); setError("");
    try {
      const { data } = await axios.put(URL, { ...settingValues(form), versie: saved.versie }, { timeout: 20000, headers: { "X-Firma-Id": loadedFirma } });
      if (current !== generation.current) return false;
      setSaved(data); setForm(settingValues(data)); return true;
    } catch (e) { if (current === generation.current) setError(settingsError(e)); return false; }
    finally { setSaving(false); }
  };
  return { form, setForm, saved, ready, dirty, loading, saving, error, invalid, save, reload: () => setReload((value) => value + 1) };
};